class $643fcf18b2d2e76f$var$ResourceInjector {
    static #_ = this.loadedResources = new Map();
    constructor(){}
    async loadScript(jsUrl, options = {}, timeout = 10000) {
        if ($643fcf18b2d2e76f$var$ResourceInjector.loadedResources.has(jsUrl)) return $643fcf18b2d2e76f$var$ResourceInjector.loadedResources.get(jsUrl);
        const promise = new Promise((resolve)=>{
            const script = document.createElement("script");
            script.src = jsUrl;
            Object.assign(script, options);
            const timer = setTimeout(()=>{
                resolve();
            }, timeout);
            script.onload = ()=>{
                clearTimeout(timer);
                $643fcf18b2d2e76f$var$ResourceInjector.loadedResources.set(jsUrl, promise);
                resolve();
            };
            script.onerror = ()=>{
                clearTimeout(timer);
                $643fcf18b2d2e76f$var$ResourceInjector.loadedResources.delete(jsUrl);
                resolve();
            };
            document.body.appendChild(script);
        });
        $643fcf18b2d2e76f$var$ResourceInjector.loadedResources.set(jsUrl, promise);
        return promise;
    }
    async loadStyle(cssUrl, options = {}, timeout = 10000) {
        if ($643fcf18b2d2e76f$var$ResourceInjector.loadedResources.has(cssUrl)) return $643fcf18b2d2e76f$var$ResourceInjector.loadedResources.get(cssUrl);
        const promise = new Promise((resolve)=>{
            const link = document.createElement("link");
            link.href = cssUrl;
            link.rel = "stylesheet";
            Object.assign(link, options);
            const timer = setTimeout(()=>{
                resolve();
            }, timeout);
            link.onload = ()=>{
                clearTimeout(timer);
                $643fcf18b2d2e76f$var$ResourceInjector.loadedResources.set(cssUrl, promise);
                resolve();
            };
            link.onerror = ()=>{
                clearTimeout(timer);
                $643fcf18b2d2e76f$var$ResourceInjector.loadedResources.delete(cssUrl);
                resolve();
            };
            document.head.appendChild(link);
        });
        $643fcf18b2d2e76f$var$ResourceInjector.loadedResources.set(cssUrl, promise);
        return promise;
    }
}
var $643fcf18b2d2e76f$export$2e2bcd8739ae039 = $643fcf18b2d2e76f$var$ResourceInjector;


export {$643fcf18b2d2e76f$export$2e2bcd8739ae039 as default};
//# sourceMappingURL=index.module.js.map
